function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var Power = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(SvgIcon, _extends({
    "data-testid": "PowerIcon"
  }, props, {
    ref: ref,
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.125 4.39 7.259 9.36a2 2 0 0 0 .078 2.55l.258.258-2.102 2.103a1 1 0 0 0 0 1.414l.707.707-4.95 4.95 1.414 1.414 4.95-4.95.707.707a1 1 0 0 0 1.414 0l2.1-2.1.163.163a2 2 0 0 0 2.642.165l4.97-3.866.707.707 1.415-1.414-2.122-2.121 2.829-2.829a1 1 0 0 0-1.415-1.414l-2.828 2.828-2.828-2.828 2.828-2.828a1 1 0 0 0-1.414-1.415L13.953 4.39l-2.12-2.122-1.415 1.415.707.707z"
    })
  }));
});
Power.displayName = 'PowerIcon';
export default Power;